import { Component, Input, OnChanges, OnInit, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators, AbstractControl } from '@angular/forms';
import { NgbActiveModal, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { IGetCodes } from 'src/app/interfaces/codes';
import { IInsertUpdateNotificationPayload, NotificationService } from 'src/app/Services/notifications/notifications.service';
import { SessionService } from 'src/app/Services/session.service';
import { ToastrService } from 'ngx-toastr';
import { INotification } from 'src/app/Models/Notification';

export interface NotificationForm {
  notificationId?: string | null;
  notificationText: string;
  affectedArea: string;
  affectedAreaTypeCode: string;
  materialId?: string | null;
  notifiedMaterialStatus?: string | null;
  severityCode: string;
  methodCode: string;
  requireAcknowledgement: boolean;
  statusCode: string;
  releaseDate?: string | null;     // ISO date string (YYYY-MM-DD)
  withdrawalDate?: string | null;  // ISO date string (YYYY-MM-DD)
  withdrawalReason?: string | null;
}

@Component({
  selector: 'app-notification-add-edit',
  templateUrl: './notification-add-edit.component.html',
  styleUrls: ['./notification-add-edit.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class NotificationAddEditComponent implements OnInit {
  @Input() screenName?: string | null;
  @Input() MaterialId?: any;
  @Input() notification:INotification |  null = null
  form!: FormGroup;


  // dropdown option sources (replace with API data if needed)
  affectedAreas:IGetCodes[] = [];

  materialStatuses: IGetCodes[] = [];
  severities : IGetCodes[] = [];
  methods: IGetCodes[] = [];
  statuses : IGetCodes[] = [];
  notifcationAcknowledgement : IGetCodes[] = [];
  // at class level
  minDate = new Date().toISOString().slice(0, 10); // 'yyyy-MM-dd'


  constructor(
    public activeModal: NgbActiveModal,
    private fb: FormBuilder,
    private notificationService: NotificationService,
    public session: SessionService,
    private toaster: ToastrService,
  ) {}

  ngOnInit(): void {
    this.form = this.fb.group(
      {
        notificationId: [
          { value: '', disabled: true }
        ],
        notificationText: ['',  [Validators.required,Validators.maxLength(2000)]],
        affectedArea: ['',Validators.required],
        materialId: [null],
        notifiedMaterialStatus: ['',Validators.required],
        severityCode: ['',Validators.required],
        methodCode: ['',Validators.required ],
        requireAcknowledgement: ["",Validators.required],
        statusCode: ['',Validators.required],
        releaseDate: [null],
        withdrawalDate: [null],
        withdrawalReason: ['']
      },
      // { validators: [this.withdrawalAfterReleaseValidator] }
    );
if (this.notification) {
  this.form.patchValue({
    notificationId: this.notification.Notification_Id ?? null,
    notificationText: this.notification.Notification_Description ?? '',
    affectedArea: this.notification.Notification_Affected_Area_Type_Code ?? '',
    materialId: this.notification.Notification_Material_Id ?? '',
    notifiedMaterialStatus: this.notification.Notified_Material_Status_Type_Code ?? '',
    severityCode: this.notification.Notification_Severity_Type_Code ?? '',
    methodCode: this.notification.Notification_Method_Type_Code ?? '',
    requireAcknowledgement: this.notification.Notification_Acknowledgement_Type_Code ?? null,
    statusCode: this.notification.NotificationStatusTypeCode ??'New',
    releaseDate: this.notification.Notification_Release_Date
      ? this.notification.Notification_Release_Date.split('T')[0]
      : '',
    withdrawalDate: this.notification.Notification_Withdrawn_Date
      ? this.notification.Notification_Withdrawn_Date.split('T')[0]
      : '',
    withdrawalReason: this.notification.Withdrawal_Reason_Description ?? ''
  });
}

    this.getNotificationAffetedArea();
    this.getNotificationMaterialStatus();
    this.getNotificationSeverity();
    this.getNotificationMethod();
    this.getNotificationAclnowledgementType();
    this.getNotificationStatus();
    if(this.MaterialId){
    this.form.get('materialId')?.setValue(this.MaterialId);
    this.form.get('materialId')?.disable();
    }

  }


  getNotificationStatus() {
    this.notificationService.GetNotificationStatus().subscribe((res) => {
      this.statuses = res;
    });
  }

  getNotificationSeverity() {
    this.notificationService.GetNotificationSevertyType().subscribe((res) => {
      this.severities = res;
    });
  }

  getNotificationMethod() {
    this.notificationService.GetNotificationMethodType().subscribe((res) => {
      this.methods = res;
    });
  }


  getNotificationAffetedArea() {
    this.notificationService.GetNotificationAffetedArea().subscribe((res) => {
      this.affectedAreas = res;
      if(this.screenName){
      this.f['affectedArea'].setValue(this.screenName );
      this.f['affectedArea'].disable();
      }
    });
  }

  getNotificationMaterialStatus() {
    this.notificationService.GetNotificationMaterialStatus().subscribe((res) => {
      this.materialStatuses = res;
    });
  }

  getNotificationAclnowledgementType() {
    this.notificationService.GetNotificationAcknowledgementType().subscribe((res) => {
      this.notifcationAcknowledgement = res;
    });
  }

  // --- validators & helpers ---------------------------------------------------
  // private withdrawalAfterReleaseValidator(group: AbstractControl) {
  //   const rel = group.get('releaseDate')?.value as NgbDateStruct | null;
  //   const wdr = group.get('withdrawalDate')?.value as NgbDateStruct | null;

  //   if (!rel || !wdr) return null;

  //   const relDate = new Date(rel.year, rel.month - 1, rel.day);
  //   const wdrDate = new Date(wdr.year, wdr.month - 1, wdr.day);

  //   return wdrDate >= relDate ? null : { withdrawalBeforeRelease: true };
  // }

  private toIso(d: NgbDateStruct | null): string | null {
    if (!d) return null;
    const mm = String(d.month).padStart(2, '0');
    const dd = String(d.day).padStart(2, '0');
    return `${d.year}-${mm}-${dd}`;
  }

  // --- UI actions -------------------------------------------------------------
  onCross() {
    this.activeModal.close(false);
  }
private toZ = (d?: string | null) => (d ? `${d}T00:00:00Z` : null);
onSave() {
  if (this.form.invalid) {
    this.form.markAllAsTouched();
    return;
  }

  const v = this.form.getRawValue() ;

  // Map UI form -> API contract
const apiPayload: IInsertUpdateNotificationPayload = {
  LoggedInUser: this.session.getUser(),
  NotificationID: this.sanitize(v.notificationId),
  NotificationDescription: this.sanitize(v.notificationText),
  NotificationMaterialId: this.sanitize(v.materialId),
  NotificationAffectedAreaTypeCode: this.sanitize(v.affectedArea),
  NotifiedMaterialStatusTypeCode: this.sanitize(v.notifiedMaterialStatus),
  NotificationSeverityTypeCode: this.sanitize(v.severityCode),
  NotificationMethodTypeCode: this.sanitize(v.methodCode),
  NotificationAcknowledgementTypeCode: this.sanitize(v.requireAcknowledgement),
  NotificationReleaseDate: this.toZ(v.releaseDate),
  NotificationWithdrawnDate: this.toZ(v.withdrawalDate),
  WithdrawalReasonDescription: this.sanitize(v.withdrawalReason),
  NotificationStatusTypeCode: this.sanitize(v.statusCode),
  ReleasedInd: 'N',
  DeletedInd: 'N',
};


  this.notificationService.InsertUpdateNotification(apiPayload).subscribe({
    next: (rows) => {
      // Close modal with what the opener likely needs (server rows or merged echo)
      this.toaster.success('Notification saved successfully','Success',{ timeOut:500, closeButton:true, progressBar:false } );
      this.activeModal.close({ request: apiPayload, response: rows });
    },
    error: (err) => {
      console.error('Error saving notification:', err);
      // optionally show a toast/snackbar
    }
  });
}

private sanitize(value: any): any {
  return value === null || value === undefined || value === '' ? null : value;
}


  get f() { return this.form.controls; }
}
